var map = {
	"./1.svg": 379,
	"./2.svg": 380,
	"./3.svg": 381,
	"./4.svg": 382,
	"./courses/ai.png": 534,
	"./courses/computer_literacy.png": 535,
	"./courses/frontend.png": 536,
	"./courses/game_design.png": 537,
	"./courses/gamedev.png": 538,
	"./courses/graphic_design.png": 539,
	"./courses/main.png": 540,
	"./courses/predprinimatelstvo.png": 541,
	"./courses/programming_basics.png": 542,
	"./courses/python.png": 543,
	"./courses/scratch.png": 544,
	"./courses/unity.png": 545,
	"./courses/video_content.png": 546,
	"./courses/videoblogging.png": 547,
	"./courses/web-razrabotka.png": 548,
	"./courses/webdev.png": 549,
	"./coursesNew/ai.png": 428,
	"./coursesNew/computer_literacy.png": 429,
	"./coursesNew/ege-informatika-desk.png": 355,
	"./coursesNew/ege-informatika.png": 356,
	"./coursesNew/frontend.png": 430,
	"./coursesNew/game_design.png": 431,
	"./coursesNew/graphic_design.png": 432,
	"./coursesNew/math-desk.png": 357,
	"./coursesNew/math.png": 358,
	"./coursesNew/predprinimatelstvo.png": 433,
	"./coursesNew/programming_basics.png": 434,
	"./coursesNew/python.png": 435,
	"./coursesNew/scratch.png": 436,
	"./coursesNew/unity.png": 437,
	"./coursesNew/videoblogging.png": 438,
	"./coursesNew/web-razrabotka.png": 439,
	"./cube.svg": 550,
	"./cursor1.svg": 350,
	"./cursor2.svg": 351,
	"./cursor3.svg": 352,
	"./cursor4.svg": 353,
	"./enter.svg": 551,
	"./globe.svg": 552,
	"./outbreak.svg": 553,
	"./puzzle.svg": 554,
	"./story1.png": 555,
	"./story2.png": 556,
	"./story3.png": 557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 774;